module.exports = __webpack_public_path__ + "img/2023-25.65f100d5.jpg";